import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BookService } from '../book.service';

@Component({
  standalone: false,
  selector: 'app-book-service',
  templateUrl: './book-service.component.html'
})
export class BookServiceComponent implements OnInit {
  provider$: Observable<string>;

  constructor(private readonly bookService: BookService) {}

  ngOnInit() {
    this.provider$ = this.bookService.getLoadedConfig().pipe(map(config => config.provider));
  }
}
